export default {
  'menu.workbenchGroup': '工作台',
  'menu.workbench': '工作台',
  'menu.activitiesGroup': '活动中心',
  'menu.activities': '活动中心',
  'menu.activityDetail': '活动详情',
  'menu.technicalNeeds': '技术需求',
  'menu.technicalNeeds.leads': '需求线索',
  'menu.technicalNeeds.demands': '技术需求',
  'menu.leads': '需求线索',
  'menu.leadDetail': '线索详情',
  'menu.customers': '客户与人脉',
  'menu.customers.organizations': '机构',
  'menu.customers.contacts': '联系人',
  'menu.relations': '客户与人脉',
  'menu.relations.organizations': '机构',
  'menu.relations.contacts': '联系人',
  'menu.organizations': '机构',
  'menu.contacts': '联系人',
  'menu.organizationDetail': '机构详情',
  'menu.contactDetail': '联系人详情',
  'menu.demands': '技术需求',
  'menu.demandDetail': '技术需求详情',
  'menu.technicalResources': '技术资源',
  'menu.technicalResources.experts': '专家资源',
  'menu.technicalResources.technologies': '技术成果',
  'menu.resources': '技术资源',
  'menu.resources.experts': '专家资源',
  'menu.resources.technologies': '技术成果',
  'menu.resources.suppliers': '机构管理',
  'menu.experts': '专家资源',
  'menu.technologies': '技术成果',
  'menu.businessConversion': '业务转化',
  'menu.businessConversion.matchmaking': '供需对接',
  'menu.businessConversion.engagements': '正式对接',
  'menu.businessConversion.opportunities': '合作商机',
  'menu.businessConversion.conversionBusinesses': '转化业务',
  'menu.matchmaking': '供需对接',
  'menu.engagements': '正式对接',
  'menu.expertDetail': '专家详情',
  'menu.technologyDetail': '技术成果详情',
  'menu.supplierDetail': '技术供应商详情',
  'menu.opportunities': '合作商机',
  'menu.opportunityDetail': '商机详情',
  'menu.businessAnalytics': '业务统计',
  'menu.businessAnalytics.businessOverview': '经营总览',
  'menu.businessAnalytics.businessScaleAnalysis': '业务规模分析',
  'menu.businessAnalytics.businessConversionAnalysis': '业务转化分析',
  'menu.businessAnalytics.businessProcessAnalysis': '业务过程分析',
  'menu.businessAnalytics.businessResultsAnalysis': '经营成果分析',
  'menu.businessAnalytics.personnelEfficiencyAnalysis': '人员效能分析',
  'menu.businessDashboard': '业务统计',
  'menu.personalProfile': '个人档案',
  'menu.personalSettings': '个人与设置',
  'menu.personalSettings.managerProfile': '个人档案',
  'menu.personalSettings.businessSettings': '业务设置',
  'menu.personalSettings.modelSettings': '模型设置',
  'menu.personalSettings.dataManagement': '数据管理',
  'menu.personalSettings.permissions': '权限管理',
  'menu.managerProfile': '个人档案',
  'menu.businessSettings': '业务设置',
  'menu.modelSettings': '模型设置',
  'menu.dataManagement': '数据管理',
  'menu.permissions': '权限管理',
  'menu.settings': '设置',
  'menu.settings.businessSettings': '业务设置',
  'menu.settings.modelSettings': '模型设置',
  'menu.settings.dataManagement': '数据管理',
  'menu.settings.mockData': '数据管理',
  'menu.globalSearch': '全局搜索',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.settings.permissions': '权限管理',
  'menu.login': '登录',
  'menu.user.login': '登录',
  'menu.user.accessDenied': '无权访问',
  'menu.accessDenied': '无权访问',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
